var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditcardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.25C0 11.9401 0.559896 12.5 1.25 12.5H13.75C14.4401 12.5 15 11.9401 15 11.25V6.66666H0V11.25ZM5 9.47916C5 9.30729 5.14062 9.16666 5.3125 9.16666H8.85417C9.02604 9.16666 9.16667 9.30729 9.16667 9.47916V10.5208C9.16667 10.6927 9.02604 10.8333 8.85417 10.8333H5.3125C5.14062 10.8333 5 10.6927 5 10.5208V9.47916ZM1.66667 9.47916C1.66667 9.30729 1.80729 9.16666 1.97917 9.16666H3.85417C4.02604 9.16666 4.16667 9.30729 4.16667 9.47916V10.5208C4.16667 10.6927 4.02604 10.8333 3.85417 10.8333H1.97917C1.80729 10.8333 1.66667 10.6927 1.66667 10.5208V9.47916ZM15 2.08333V3.33333H0V2.08333C0 1.39322 0.559896 0.833328 1.25 0.833328H13.75C14.4401 0.833328 15 1.39322 15 2.08333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditcardIcon);
export default __webpack_public_path__ + "static/media/creditcard-icon.7993f834e94e87a8c5dbbfe41c386c53.svg";
export { ForwardRef as ReactComponent };